import React, { useContext, useEffect } from "react";
import { IonButton, IonCard, IonCardHeader, IonCardContent, IonSearchbar, IonLoading, IonIcon } from "@ionic/react";
import { ApplicationContext, ProviderContext } from "../ApplicationState";
import * as ApiService from "../services/ApiService";
import { useHistory, useLocation } from "react-router";
import { IUserProps } from "../models/user";
import { addCircle, checkmarkCircle, closeCircle } from "ionicons/icons";
import { DataGrid } from "@mui/x-data-grid"; // Importing DataGrid from MUI
import EditAttributesIcon from '@mui/icons-material/EditAttributes';
import "./Components.css";
import { convertArrayToObject } from "../services/Helpers";

const ProvidersComponent: React.FC<any> = (props: any) => {
  const providerContext = useContext(ProviderContext);
  const history = useHistory();
  const location: any = useLocation();
  const { userState } = useContext(ApplicationContext);

  const { providerState } = useContext(ProviderContext);
  const [searchText, setSearchText] = React.useState("");
  const [providers, setProviders] = React.useState([]);
  const [filteredProviders, setFilteredProviders] = React.useState([]);
  const [showLoading, setShowLoading] = React.useState(true);
  const [type, setType] = React.useState("");

  useEffect((): any => {

    let isSubscribed = true;
    let user = userState.authenticatedUser;
    let userType: any = props.type;
    
    if (location.state?.type !== undefined) userType = location.state?.type;

    if (providerState !== undefined) {
      if (providerState.providerId !== undefined && providerState.providerId !== "") {
        setShowLoading(true);
        
        ApiService.fetchProviders(userState.authenticatedUser).then((data) => {
          if (isSubscribed) {
            if (data) {
              setProviders(data);
              setFilteredProviders(data);
              setShowLoading(false);
              setType(userType);
            }
          }
        });
      }
    }

    return () => (isSubscribed = false);
  }, [providerState, location]);

  function onProviderSelectionChange(provider: any) {
    history.push("/provider", { provider: provider });
  }

  function addNewProvider() {
    history.push("/provider", { provider: {} });
  }

  function onSearchTextChange(searchTerm: string) {
    setSearchText(searchTerm);
    if (searchTerm === "") {
      setFilteredProviders(providers);
      return;
    }
    setFilteredProviders(
      providers.filter((p) => {
        return (
          p.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          p.providerName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          p.providerCode?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      })
    );
  }

  const columns = [
    {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: (params: any) => {
        return params.row.status === "Active" ? (
          <IonIcon icon={checkmarkCircle} color="success" />
        ) : (
          <IonIcon icon={closeCircle} color="danger" />
        );
      },
    },
    { field: "providerName", headerName: "Provider", width: 250 },
    { field: "providerCode", headerName: "Code", width: 150 },
    { field: "email", headerName: "Contact Email", width: 250 },
    { field: "providerType", headerName: "Type", width: 150 },
    {
      field: "actions",
      headerName: "Actions",
      renderCell: (params: any) => {
        return (
          <EditAttributesIcon onClick={() => onProviderSelectionChange(params.row.fullObject)} className="d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer", color: "#ff751a" }} fontSize="large">Edit</EditAttributesIcon>
        );
      },
    },
  ];

  const rows = filteredProviders.map((a) => {

    return {
      id: a.id, // Ensure unique 'id' is provided for each row
      status: a.isActive ? "Active" : "Inactive",
      providerName: a.providerName,
      providerCode: a.providerCode,
      email: a.email,
      providerType: a.providerType?.name,
      fullObject: a, // Pass the full object here
    };
  });

  return (
    <div>
      <div hidden={userState?.authenticatedUser?.signInUserSession.idToken.jwtToken['custom:Roles'] === 'Provider'}>
        <IonButton onClick={addNewProvider}>
          Register New Provider <IonIcon icon={addCircle} />
        </IonButton>
      </div>
      <div className="col-4 float-end">
        <IonSearchbar
          value={searchText}
          onIonChange={(e) => onSearchTextChange(e.detail.value!)}
          showCancelButton="always"
        ></IonSearchbar>
      </div>
      <div className="col-12 float-end">
        <DataGrid
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          pageSizeOptions={[5, 10, 20, 50, 100]}
          disableRowSelectionOnClick
          autoHeight={false}
          loading={showLoading}
        />

        {/* <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={"Please wait..."}
          duration={5000}
        /> */}
      </div>
    </div>
  );
};

export default ProvidersComponent;
